var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',{staticClass:"full-width",style:({maxWidth: _vm.maxWidth || 'unset'})},[_c('apexchart',{attrs:{"options":_vm.chartOptions,"type":_vm.chartOptions.type,"series":_vm.series}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }